import { useRef } from 'react'
import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'
import { generateUniqueId } from '../shared/utils/basic'

interface IProps {}

export const StyledChatIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    const uniqueId = useRef(generateUniqueId())
    return (
        <StyledSvg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <g clipPath={`url(#clip-${uniqueId})`}>
                <path
                    d='M6 7.5V20.0608C6 20.4611 6.44706 20.6991 6.77919 20.4755L9.07341 18.9314C9.15592 18.8758 9.25313 18.8462 9.3526 18.8462H21.5C21.7761 18.8462 22 18.6223 22 18.3462V7.5C22 7.22386 21.7761 7 21.5 7H6.5C6.22386 7 6 7.22386 6 7.5Z'
                    strokeWidth='1.3'
                    fill='none'
                />
                <path
                    d='M26 12V24.059C26 24.4597 25.5522 24.6976 25.2202 24.4734L22.6268 22.722C22.5442 22.6662 22.4467 22.6364 22.347 22.6364H12'
                    strokeWidth='1.3'
                    strokeLinecap='round'
                    fill='none'
                />
            </g>
            <defs>
                <clipPath id={`clip-${uniqueId}`}>
                    <rect stroke='none' />
                </clipPath>
            </defs>
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    &, rect {
        height: 32px;
        width: 32px;
    }

    stroke: ${p => p.stroke || p.theme.bgColor};
    fill: ${p => p.fill || p.theme.bgColor};
`
